import { makeRequest } from "./index";

export async function getDocumentsWithFilters(filters) {
  return await makeRequest("GET", "documents", null, filters);
}

export async function getDocuments() {
  return await makeRequest("GET", "documents");
}

export async function createDocument(data) {
  return await makeRequest("POST", "documents", data);
}

export async function updateDocument(documentId, data) {
  return await makeRequest("PUT", `documents/${documentId}`, data);
}
